import { HTTP, HMD_BACKEND_API_URL } from "@/utils/http-common";

const AUTH_TOKEN_KEY = "token";
const ACCESS_TOKEN_KEY = "hmd_access_token";

const URL_AUTHENT = "/account/login/";
const URL_REGISTER = "/account/registration/";
const URL_LOGOUT = "/account/logout/";

export function login(parent, creds, redirect) {
  HTTP.post(URL_AUTHENT, {
    email: creds.email,
    password: creds.password,
    recaptchaToken: creds.recaptchaToken
  })
    .then(function(response) {
      setAuthorizationToken(response.data.key);
      localStorage.setItem(
        "user",
        JSON.stringify({
          username: response.data.username,
          admin: response.data.admin,
          company: response.data.company,
          company_id: response.data.company_id
        })
      );
      if (!redirect) {
        redirect = "/";
      }
      // Redirect to a specified router
      parent.$router.push("/");
    })
    .catch(function(error) {
      if (error.response) {
        parent.$store.commit("push", {
          msg: error.response.data["non_field_errors"][0],
          color: "error"
        });
      } else {
        parent.$store.commit("push", { msg: error + "", color: "error" });
      }
    });
}

export function register(parent, account) {
  return new Promise((resolve, reject) => {
    HTTP.post(URL_REGISTER, account)
      .then(function(response) {
        /* setAuthorizationToken(response.data.key)    */
        // Redirect to a specified router
        parent.$router.push("/signup/activation");
      })
      .catch(function(error) {
        // getValitdationErrors(parent, error)
        for (var propt in error.response.data) {
          if (error.response.data[propt]) {
            if (propt !== "non_field_errors") {
              parent.errors.add(propt, error.response.data[propt]);
            } else {
              parent.$store.commit("push", {
                msg: error.response.data[propt][0],
                color: "error"
              });
            }
          }
        }
        reject(error); // the request failed
      });
  });
}

export function getValidationErrors(parent, error) {
  for (var propt in error.response.data) {
    if (error.response.data[propt]) {
      if (propt !== "non_field_errors") {
        parent.errors.add(propt, error.response.data[propt]);
      } else {
        parent.$store.commit("push", {
          msg: error.response.data[propt],
          color: "error"
        });
      }
    }
  }
}

export function getAuthorizationToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}

function clearSession() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem("user");
}

// Get and store id_token in local storage
export function setAuthorizationToken(token) {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
}

export function logout() {
  HTTP.get(URL_LOGOUT)
    .then(resp => {
      clearSession();
      window.location.href = "/";
    })
    .catch(e => {
      clearSession();
      window.location.href = "/";
    });
}

export function requireAuth(to, from, next) {
  if (!getAuthorizationToken()) {
    next({
      path: "signin",
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
}

export function redirectTo(errorCode) {
  if (errorCode === 404) {
    window.location.href = "/#/notfound";
  } else if (errorCode === 403) {
    // parent.$store.commit('push', {msg: 'unauthorized action', color: 'error'});
    window.location.href = "/#/unauthorized";
  }
}
